export default "__VITE_ASSET__Cb5v1TeC__"